import { addToast } from '@app/components/various/Toasts';
import { compiledPaths } from '@app/paths';
import { createAccount } from '@app/services/accountRepository';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { ACCOUNTS_QUERY_KEY } from '../accounts/useAccounts';
import { BUYERS_QUERY_KEY } from '../accounts/useBuyers';

export const useCreateAccount = () => {
  const { t } = useTranslation(['accounts', 'common']);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createAccount,
    onError: () => {
      addToast(t('accounts:account_create_fail'));
    },
    onSuccess: (data, payload) => {
      addToast(t('accounts:account_created.title', { accountName: payload.accountName }), {
        actions: [
          {
            label: t('accounts:view_account'),
            to: compiledPaths.ACCOUNT_DETAILS({ accountId: data.account.account }),
          },
          {
            label: t('common:dismiss'),
          },
        ],
        description: t('accounts:account_created.description'),
        duration: 10000,
      });
      queryClient.invalidateQueries({ queryKey: [BUYERS_QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: [ACCOUNTS_QUERY_KEY] });
    },
  });
};
